import {
  codeAnnualFee,
  codeMdr,
  codeMembershipFee,
  codeSaleDeadline,
  codeTor
} from '../../constants/commercialConditions';
import {
  ALIMENTACAO,
  CULTURA,
  FROTA,
  MOBILIDADE,
  MULTIBENEFICIOS_LIMITE,
  MULTIBENEFICIOS_SALDO,
  NATAL,
  REFEICAO,
  ALIMENTACAO_PAT,
  REFEICAO_PAT
} from '../../constants/products';

export const getProductName = (productCode) => {
  switch (Number.parseInt(productCode, 10)) {
    case REFEICAO:
      return 'REFEIÇÃO AUXÍLIO';
    case ALIMENTACAO:
      return 'ALIMENTAÇÃO AUXÍLIO';
    case REFEICAO_PAT:
      return 'REFEIÇÃO PAT';
    case ALIMENTACAO_PAT:
      return 'ALIMENTAÇÃO PAT';
    case MULTIBENEFICIOS_LIMITE:
      return 'MULTIBENEFÍCIOS LIMITE *';
    case MULTIBENEFICIOS_SALDO:
      return 'MULTIBENEFÍCIOS SALDO *';
    case FROTA:
      return 'FROTA';
    case NATAL:
      return 'NATAL';
    case CULTURA:
      return 'CULTURA';
    case MOBILIDADE:
      return 'MOBILIDADE';
    default:
      return '';
  }
};

const showMoney = (value) => {
  let moneyGroup = value.toString().split('.');

  if (moneyGroup.length === 2) {
    if (moneyGroup[1].length === 1) {
      moneyGroup[1] = moneyGroup[1] + '0';
    }
  }

  if (moneyGroup.length === 1) {
    moneyGroup.push('00');
  }

  return moneyGroup[0] + ',' + moneyGroup[1];
};

export const getConditionMdr = (conditions) => {
  const mdr = conditions.filter((condition) => {
    if (condition.type.code === codeMdr) {
      return condition.value;
    }
  });

  if (mdr.length) {
    return (
      mdr[0].value.toString().replace('.', ',') +
      '% sobre o valor bruto de cada transação'
    );
  }

  return 'Não se aplica';
};

// Prazo
export const getConditionSaleDeadline = (conditions) => {
  const saleDeadline = conditions.filter((condition) => {
    if (condition.type.code === codeSaleDeadline) {
      return condition.value;
    }
  });

  if (saleDeadline.length) {
    return (
      saleDeadline[0].value.toString() +
      ' dias corridos após a efetuação da venda'
    );
  }

  return 'Não se aplica';
};

// Tarifa de Adesão
export const getConditionMembershipFee = (conditions) => {
  const membershipFee = conditions.filter((condition) => {
    if (condition.type.code === codeMembershipFee) {
      return condition.value;
    }
  });

  if (membershipFee.length) {
    return ' ' + showMoney(membershipFee[0].value);
  }

  return ' 0,00';
};

export const getConditionTor = (conditions) => {
  const tor = conditions.filter((condition) => {
    if (condition.type.code === codeTor) {
      return condition.value;
    }
  });

  if (tor.length) {
    return ' ' + showMoney(tor[0].value) + ' por liquidação';
  }

  return ' 0,00';
};

// Tarifa de Anuidade
export const getConditionAnnualFee = (conditions) => {
  const annualFee = conditions.filter((condition) => {
    if (condition.type.code === codeAnnualFee) {
      return condition.value;
    }
  });

  if (annualFee.length) {
    return ' ' + showMoney(annualFee[0].value);
  }

  return ' 0,00';
};
